import { CommissionsSummaryAction } from './actions';

import {
  COMMISSIONS_SUMMARY_REQUEST_START,
  COMMISSIONS_SUMMARY_REQUEST_SUCCESS,
  COMMISSIONS_SUMMARY_REQUEST_FAIL,
  COMMISSIONS_DETAIL_REQUEST_SUCCESS,
  COMMISSIONS_DATA_RESET, COMMISSIONS_DETAIL_REQUEST_START, COMMISSIONS_DETAIL_REQUEST_FAIL,
} from './types';

type CommissionsSummaryState = {
  details: any,
  loadingState: string,
  results: any
};

const INITIAL_STATE: CommissionsSummaryState = {
  details: null,
  loadingState: 'UNINITIALISED',
  results: null
};

export const reducer = (
  state = INITIAL_STATE,
  action: CommissionsSummaryAction
): CommissionsSummaryState => {
  switch (action.type) {
    case COMMISSIONS_SUMMARY_REQUEST_START:
      return {
        ...state,
        loadingState: 'LOADING',
        results: null
      };

    case COMMISSIONS_SUMMARY_REQUEST_SUCCESS:
      return {
        ...state,
        loadingState: 'LOADED',
        results: action.payload
      };

    case COMMISSIONS_SUMMARY_REQUEST_FAIL:
      return {
        ...state,
        loadingState: 'ERROR',
        results: null
      };

    case COMMISSIONS_DETAIL_REQUEST_START:
      return {
        ...state,
        loadingState: 'DETAILS_LOADING',
        details: null,
      };

      case COMMISSIONS_DETAIL_REQUEST_FAIL:
      return {
        ...state,
        loadingState: 'DETAILS_ERROR',
        details: null,
      };

    case COMMISSIONS_DETAIL_REQUEST_SUCCESS:
      return {
        ...state,
        details: action.payload,
        loadingState: 'DETAILS_LOADED'
      };

    case COMMISSIONS_DATA_RESET:
      return {
        ...state,
        results: null,
        details: null,
        loadingState: 'LOADED'
      };

    default:
      return state;
  }
};